// Dependencies
import * as React from 'react';

// Hooks
import useLegalMenu from '../../hooks/useLegalMenu';

// Components
import Container from '../container/container';

export default function Footer() {
  const legalMenu = useLegalMenu();

  return (
    <div className="bottom">
      <Container flex alignItems="center" justifyContent="space-between">
        <p className="copyright">
          Copyright &copy; {new Date().getFullYear()} Vida Consultancy Ltd
        </p>

        <div className="legal-wrapper">
          <nav className="legal">
            <ul>
              {legalMenu?.menuItems?.nodes.map((menuItem) => (
                <li key={menuItem?.id}>
                  <a href={menuItem?.url}>{menuItem?.label}</a>
                  <span className="pipe">|</span>
                </li>
              ))}
            </ul>
          </nav>

          <span className="calling-card">
            Powered by{' '}
            <a href="https://pixelsmatter.io" target="_blank" rel="noreferrer">
              PixelsMatter
            </a>
          </span>
        </div>
      </Container>
    </div>
  );
}
